import { render } from "./BaseDropdown2.vue?vue&type=template&id=ad47b5d0"
import script from "./BaseDropdown2.vue?vue&type=script&lang=ts"
export * from "./BaseDropdown2.vue?vue&type=script&lang=ts"
script.render = render

export default script